@if (hasHealthPlan !== undefined) {
  <div
    class="cookie-modal-wrapper">
    <div [@appearSlowlyAnimation] class="bottom-modal" id="modal-description"
      role="dialog">
      <div [ngClass]="isMobile ? 'mobile-css' : 'desktop-css'"
        class="bottom-modal-body white-bg">
        <div>
          <div class="bottom-modal-img-container">
            <img alt="important" class="bottom-modal-img" height="46"
              loading="lazy" ngSrc="assets/scalableVectorGraphics/important.svg" width="46">
            </div>
            <div class="consent-text mt-1">
              @if (ntConsentStatus === NtConsentStates.ALL_TERMS_ACCEPTED_NT_PRESCRIPTION_CONSENT_REQUIRED) {
                <span [innerHTML]="'consentModal.msg3' | translate"></span>
              }
              @if (ntConsentStatus === NtConsentStates.NT_INSURANCE_CONSENT_REQUIRED) {
                <span [innerHTML]="'consentModal.msg1' | translate"></span>
              }
              @if (ntConsentStatus === NtConsentStates.NT_INSURANCE_AND_PRESCRIPTION_CONSENTS_REQUIRED) {
                <span [innerHTML]="'consentModal.msg2' | translate"></span>
              }
              @if (ntConsentStatus === NtConsentStates.ALL_TERMS_ACCEPTED_NT_INSURANCE_CONSENT_REQUIRED) {
                <span [innerHTML]="'consentModal.msg1' | translate"></span>
              }
            </div>
            <div class="text-center mt-4">
              <u><a (click)="expandText = !expandText" class='link-color' tabindex="0">
              {{ expandText ? ("shared.readLess" | translate) : "shared.readMore" | translate }}</a></u>
            </div>
            @if (expandText) {
              <div [innerHTML]="'shared.whyWeNeedConsentText' | translate" appLinkHandler class="mt-4"></div>
            }
            @if (((hasHealthPlan || !hasHealthPlan) && ntInsuranceCheck && !ntPrescriptionCheck && sessionContext.termsOutput.prescriptionsAccepted)) {
              <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}" class="bottom-modal-btn-container my-4">
                <button (click)="onGiveConsents()" class="btn btn-primary mt-2"
                  style="margin:0; min-width: 12rem;">
                  <div class="give-consent-button-text">{{ "newUser.giveConsent" | translate }}</div>
                </button>
                <button (click)="onClose()"
                  class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2">{{ "shared.back" |translate }}
                </button>
              </div>
            } @else {
              <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}" class="bottom-modal-btn-container my-4">
                <button (click)="onGiveConsents()" class="btn btn-primary mt-2" role="button"
                  style="margin:0; min-width: 12rem;">
                  <div class="give-consent-button-text">{{ "newUser.giveConsent" | translate }}</div>
                </button>
                <button (click)="onLogout()" class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2"
                  role="button">{{ "shared.logOut" | translate | uppercase }}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

